import React from 'react';
import classNames from 'classnames';

import { CoreLink, DynamicMediaItem } from '@uncinc/react-drupal-core';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { DEFAULT_EMAIL_ADDRESS } from '../../../../config/constants';
import type { ProfileDefault } from '../../../../types/uncinc_profile/profile';

import './style.scss';

interface ProfileTeaserSmallProps extends React.ComponentPropsWithoutRef<'div'> {
  entity: ImmutableEntity<ProfileDefault>;
  classes: string;
}

const ProfileTeaserSmall: React.FC<ProfileTeaserSmallProps> = ({ entity, classes, ...props }) => {
  const profile = entity.toJS();
  const profileName = [
    profile.field_first_name[0].value,
    profile.field_last_name[0]?.value,
  ].join(' ');

  const profileFunction = profile.field_function?.[0]?.entity.name[0].value;
  const profileImage = profile.field_media_item[0];
  const profileEmail = profile.field_email_address?.[0]?.value || DEFAULT_EMAIL_ADDRESS;

  return (
    <div className={classNames('ProfileTeaserSmall', classes)} {...props}>
      {profileImage && (
        <DynamicMediaItem
          media={profileImage}
          imageAspectRatio="1_1"
        />
      )}

      <div className="ProfileTeaserSmall__content">
        <h3 itemProp="name" className="ProfileTeaserSmall__name asH4">
          {profileName}
        </h3>

        {profileFunction && (
          <span className="ProfileTeaserSmall__function text--small">
            {profileFunction}
          </span>
        )}

        <CoreLink
          className="ProfileTeaserSmall__link text--small"
          href={`mailto:${profileEmail}`}
        >
          {profileEmail}
        </CoreLink>
      </div>
    </div>
  );
};

export default ProfileTeaserSmall;
